// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"78":"8cd54e74db5ac2c8","835":"a8a95ce40bb7d2a8","987":"0a5c40e181e43308"}[chunkId] + ".css";
};